/**
 * Configuración global de endpoints
 * Se adjuntan a la API_BASE_SRC
 * Ej: API_BASE_SRC + '/' + endpoints.EJEMPLO
 */
const API_BASE_SRC = process.env.VUE_APP_API_BASE_SRC || "";
const ASO_BASE_SRC = process.env.VUE_APP_ASO_BASE_SRC || "";
const BASE_PATH = `${API_BASE_SRC}/empresas/PC`;
export const EMPRESA_CONSULTA = `${BASE_PATH}/consulta`;
export const OBTENER_OFERTA = `${BASE_PATH}/obtenerOferta`;
export const CONFIRMAR = `${BASE_PATH}/confirmar`;
export const CA_GET = `${API_BASE_SRC}/carroAbandonado/consultaDatosDeAbandono`;
export const CA_SET = `${API_BASE_SRC}/carroAbandonado/persistirNuevoPaso`;

/** Reactivo Web */
const BASE_PATH_REACTIVO = `${API_BASE_SRC}/empresas/rw`;
export const RW_OBTENER_OFERTA = `${BASE_PATH_REACTIVO}/consultarOferta`;
export const RW_CONFIRMAR_OFERTA = `${BASE_PATH_REACTIVO}/confirmarOferta`;

/** Agro **/
export const VALIDAR_CUIT = `${API_BASE_SRC}/api/validacion/persona/`;
export const RW_OBTENER_OFERTA_AGRO = `${API_BASE_SRC}/empresas/rw/consultarOfertaAgro`;
export const GENERAR_OTP = `${API_BASE_SRC}/seguridad/generarClaveOTP`;
export const VALIDAR_OTP = `${API_BASE_SRC}/otp/validar`;
export const AGRO_BOLD_CULTIVOS = `${API_BASE_SRC}/agro/bold/cultivos`;
/** Agro BdC **/
const BASE_PATH_AGRO = `${API_BASE_SRC}/agro`;
export const AGRO_CONVENIOS_LISTADO = `${BASE_PATH_AGRO}/convenios/listado`;
export const AGRO_CONVENIOS_MERCHANTS = `${BASE_PATH_AGRO}/convenios/merchants`;
export const AGRO_CONVENIOS_CATEGORIAS = `${BASE_PATH_AGRO}/convenios/categorias`;
export const AGRO_CONVENIOS_TIPOS_PRODUCTO = `${BASE_PATH_AGRO}/convenios/tipo-producto`;
export const AGRO_CONVENIOS_FILTROS = `${BASE_PATH_AGRO}/convenios/filtros`;
export const AGRO_CONVENIOS_BY_MERCHANT_ID = `${BASE_PATH_AGRO}/merchants/{id}/convenios`;
export const AGRO_CONVENIOS_FILTRO_TIPO_PRODUCTO = `${BASE_PATH_AGRO}/convenios/tipo-producto`;
export const AGRO_CONVENIOS_SEND_NOTIFICATION_EMAIL = `${BASE_PATH_AGRO}/notificaciones/email`;
export const AGRO_ES_CLIENTE = `${API_BASE_SRC}/empresas/esCliente`;
export const AGRO_GRANTING_TICKET = `${ASO_BASE_SRC}/TechArchitecture/mx/grantingTicket/V02`;
export const AGRO_AVAILABLE_QUALIFICATIONS = `${ASO_BASE_SRC}/risk-limits/v0/available-qualifications/`;
export const ENVIAR_SOLICITUD = `${API_BASE_SRC}/agro/merchants/{id}/sendEmail`;
